import { msalInstance } from "..";
import { loginRequest } from "../authConfig";
import { SingleRequest } from "../hooks/useFetchWithMsal";

export async function loginPrompt(method: string, endpoint: string, data: any, addNotifications: Function, afterFunction: Function, authFailureFunction: Function | undefined = undefined) {
    const currentAccount = msalInstance.getActiveAccount();
    let loginPromptResult = undefined as any;
    try {
        loginPromptResult = await msalInstance.loginPopup({ ...loginRequest, login_hint: currentAccount?.username } as any);
    } catch (ex) {
        authFailureFunction?.();
    }
    if (loginPromptResult) {
        const requestResult = await SingleRequest(loginPromptResult.accessToken, method, endpoint, data, addNotifications)
            .then((data: any) => {
                afterFunction(data?.apiResult, data?.error);
                if ((loginPromptResult?.idTokenClaims as any)?.oid !== (currentAccount?.idTokenClaims as any)?.oid) {
                    msalInstance.setActiveAccount(loginPromptResult?.account);
                    window.location.reload();
                }
            });
        return requestResult;
    }
    return;
}